import React from 'react';
import { Card } from 'react-bootstrap';
// import ReactHtmlParser from 'react-html-parser';
import PropTypes from 'prop-types';

import { __ } from '../../../helpers/translations';
import Caption from '../survey/components/inputs/Caption';

import { ReportLeadershipBarChart } from './ReportLeadershipBarChart';

export function ReportLeadershipChartSection({ respondent, section }) {
  const { report } = respondent;
  const result = report[section.facet];
  const result2 = section.facet === 'Implicit' ? [] : report[`${section.facet}Other`] || [];

  return (
    <>
      {section.facet === 'LeadershipQualitative' && result && (
      <Card key={`report-section-feedback-${section.facet}`} className="pagebreak py-3 my-3">
        <Card.Body>
          <div className="m-3 p-3">
            <h2>{__('G153')}</h2>
          </div>
          <div className="m-3 p-3">
            {(Array.from(report[section.facet])).map((feedback, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={`report-section-feedback-${section.facet}-${index}`}>
                <i>{feedback}</i>
                <hr />
              </div>
            ))}
          </div>
        </Card.Body>
      </Card>
      )}
      {section.facet !== 'LeadershipQualitative' && result && (
      <Card key={`report-section-chart-${section.key}`} className="pagebreak py-3 my-3">
        <Card.Body>
          <div className="m-3 p-3">
            <h2>{section.title}</h2>
          </div>
          <div className="mx-5">
            <ReportLeadershipBarChart
              labels={Object.keys(result).reverse()}
              data={Object.values(result).map((num) => Number(num).toString()).reverse()}
              data2={Object.values(result2).map((num) => Number(num).toString()).reverse()}
              highlightHeader={section.highlightHeader}
            />
            <Caption data={section.sections} />
          </div>
        </Card.Body>
      </Card>
      )}
    </>
  );
}

ReportLeadershipChartSection.propTypes = {
  respondent: PropTypes.shape({
    report: PropTypes.object,
  }),
  section: PropTypes.object,
};
